import * as React from 'react'

import { NavigationRoutesFn } from 'modules/core/lib/react-router'

import AddMembersGroupPage from '../pages/AddMembersGroupPage'
import DeleteGroupPage from '../pages/DeleteGroupPage'
import EditGroupPage from '../pages/EditGroupPage'
import JoinGroupPage from '../pages/JoinGroupPage'
import LeaveGroupPage from '../pages/LeaveGroupPage'
import NewGroupPage from '../pages/NewGroupPage'
import RemoveMembersGroupPage from '../pages/RemoveMembersGroupPage'

const RootPage = React.lazy(() => import('modules/posts/pages/RootPage'))

const groupsRoutes: NavigationRoutesFn = (navigation) => [
  {
    path: navigation.dashboard.groups.path,
    element: <RootPage kind="groups" />,
    children: [
      {
        path: navigation.dashboard.groups.new.path,
        element: <NewGroupPage />,
      },
      {
        path: navigation.dashboard.groups.join.path,
        element: <JoinGroupPage />,
      },
      {
        path: navigation.dashboard.groups.id.path,
        children: [
          {
            path: navigation.dashboard.groups.id.leave.path,
            element: <LeaveGroupPage />,
          },
          {
            path: navigation.dashboard.groups.id.edit.path,
            element: <EditGroupPage />,
          },
          {
            path: navigation.dashboard.groups.id.delete.path,
            element: <DeleteGroupPage />,
          },
          {
            path: navigation.dashboard.groups.id.addMembers.path,
            element: <AddMembersGroupPage />,
          },
          {
            path: navigation.dashboard.groups.id.removeMembers.path,
            element: <RemoveMembersGroupPage />,
          },
        ],
      },
    ],
  },
]

export default groupsRoutes
